import { Variable } from '@ff-scene-plugins/gift-shared/Variable';
import { ColorAttributeInput } from '@gift-variable-plugins/color-attribute-shared/ColorAttributeInput';
import { ColorAttributeOptions } from '@gift-variable-plugins/color-attribute-shared/ColorAttributeOptions';
import { ColorAttributeInputControl } from './ColorAttributeInputControl';

export const colorAttributePdpPlugin: Variable.Plugin<ColorAttributeOptions, ColorAttributeInput> = {
    pluginId: 'color-attribute',
    InputControl: ColorAttributeInputControl,
    toFfCanvas: () => []
};